import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18EmojiG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h18v18H0z"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M9 2.21a6.79 6.79 0 1 0 0 13.58A6.79 6.79 0 0 0 9 2.21m0 1.2a5.59 5.59 0 1 1 0 11.18A5.59 5.59 0 0 1 9 3.41"
      }), /*#__PURE__*/jsx("path", {
        fill: props.iconColor ? props.iconColor : "#010505",
        d: "M6.95 7.02a.6.6 0 0 1 .097 1.192l-.107.008a.6.6 0 0 1-.097-1.192zm4 0a.6.6 0 0 1 .097 1.192l-.107.008a.6.6 0 0 1-.097-1.192zm-4.09 3.611a.6.6 0 0 1 .849.01 1.806 1.806 0 0 0 2.435.135l.122-.11.03-.03a.6.6 0 0 1 .918.765l-.07.083-.032.033a3.005 3.005 0 0 1-4.26-.037.6.6 0 0 1 .008-.849"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18EmojiG$1 = Svg18EmojiG;

export { Svg18EmojiG$1 as default };
